import { FC } from 'react';
import BordOneToneIcon from '../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import './AgentChatWindowHeader.scss';

const AgentChatWindowHeader: FC = () => {
  return (
    <div className="agentChatWindowHeader">
      <BordOneToneIcon variant="bordMascot" customWidth="24px" />

      <div className="headerText">
        <div className="titleText">Bordi, tu asistente operativo</div>
        <div className="betaTag">Beta</div>
      </div>
    </div>
  );
};

export default AgentChatWindowHeader;
